import React, {
  useEffect,
  useRef,
} from 'react';
import Hls from 'hls.js';

const HlsVideo = ({ src, ...rest }: React.ComponentProps<'video'>) => {
  const videoRef = useRef();

  useEffect(() => {
    if (!src) return;

    const hls = new Hls({});

    if (Hls.isSupported()) {
      hls.loadSource(src);
      // @ts-ignore
      hls.attachMedia(videoRef.current);
      hls.on(Hls.Events.ERROR, (err) => {
        console.error(err);
      });
    }
  }, [src]);

  return (
    <video
      // @ts-ignore
      ref={videoRef}
      controls
      {...rest}
      src={src}
    />
  );
};

export default HlsVideo;
